import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoajantaelloracabs() {



const cardData = {
  keyword: "Pune to Ajanta Ellora Cabs",
  heading: "Lotus Cab: Pune to Ajanta Ellora Cabs",

  headingDescription:
    "Lotus Cab offers reliable and comfortable Pune to Ajanta Ellora Cabs for heritage and spiritual travel. Whether you are planning a same-day trip, 2-day sightseeing package, family tour, or corporate group visit, our well-maintained AC sedan and SUV fleet ensures a smooth long-distance journey. Our experienced chauffeurs are familiar with the Pune to Chhatrapati Sambhaji Nagar highway route and major tourist landmarks. We provide transparent per-km pricing with one-way, round-trip, and tour package flexibility. With 24/7 booking assistance and doorstep pickup in Pune, we make your Ajanta Ellora tour comfortable, affordable, and completely stress-free.",

  top: "Top Places to Visit in Ajanta Ellora Region with Lotus Cab",

  topPlaces: [
    {
      title: "Ajanta Caves",
      description:
        "Ajanta Caves are UNESCO World Heritage Buddhist cave monuments dating back to the 2nd century BCE. The caves are famous for ancient paintings and intricate rock-cut sculptures. They depict stories of Buddha’s life and teachings. Surrounded by scenic hills and greenery, the location offers a peaceful atmosphere. Ideal for history and art lovers. A must-visit heritage destination near Pune."
    },
    {
      title: "Ellora Caves",
      description:
        "Ellora Caves represent a blend of Buddhist, Hindu, and Jain architecture. The Kailasa Temple carved from a single rock is the main attraction. The caves date between the 6th and 10th centuries. The massive carvings reflect incredible craftsmanship. Popular among tourists and researchers. A world-famous heritage site."
    },
    {
      title: "Grishneshwar Temple",
      description:
        "Grishneshwar Temple is one of the 12 Jyotirlingas of Lord Shiva. Located near Ellora Caves, it attracts devotees from across India. The temple architecture is beautifully carved. It holds strong spiritual significance. Ideal for pilgrimage and family visits. A sacred stop during Ajanta Ellora tour."
    },
    {
      title: "Daulatabad Fort",
      description:
        "Daulatabad Fort is a historic hill fort near Aurangabad. Known for its strong defense architecture and panoramic views. The fort has underground tunnels and ancient structures. Popular among adventure lovers and history enthusiasts. Offers breathtaking sunrise views. A fascinating historical attraction."
    },
    {
      title: "Bibi Ka Maqbara",
      description:
        "Bibi Ka Maqbara is often called the Mini Taj of Deccan. Built in memory of Mughal emperor Aurangzeb’s wife. The monument showcases Mughal architecture. Beautiful gardens surround the structure. Popular tourist attraction in Sambhaji Nagar. Ideal for photography and sightseeing."
    },
    {
      title: "Panchakki",
      description:
        "Panchakki is an ancient water mill in Aurangabad. Known for its engineering brilliance. The water channel system dates back centuries. It served pilgrims and travelers historically. Peaceful location with greenery. A unique heritage attraction."
    },
    {
      title: "Aurangabad Caves",
      description:
        "Aurangabad Caves are lesser-known but historically significant. Carved into hills, they feature Buddhist sculptures. Ideal for quiet exploration. Less crowded than Ajanta and Ellora. Scenic hilltop views available. A hidden historical gem."
    },
    {
      title: "Jayakwadi Dam",
      description:
        "Jayakwadi Dam is one of Maharashtra’s largest dams. Located near Sambhaji Nagar, it offers scenic sunset views. Popular for bird watching and photography. Ideal for peaceful family visits. Surrounded by natural beauty. A relaxing stop during your trip."
    }
  ],

  services: [
    {
      name: "Pune to Ajanta Caves Cab",
      description:
        "Reliable cab service from Pune to Ajanta Caves with experienced drivers. AC sedan and SUV options available. Transparent per-km pricing ensured. Comfortable long-distance travel guaranteed. Ideal for family and heritage trips. 24/7 booking support provided."
    },
    {
      name: "Pune to Ellora Caves Taxi",
      description:
        "Comfortable taxi service from Pune to Ellora Caves. Professional drivers ensure safe highway journey. Suitable for same-day or extended tours. Clean and sanitized vehicles available. Transparent billing policy maintained. Hassle-free travel guaranteed."
    },
    {
      name: "Ajanta Ellora Package from Pune",
      description:
        "Complete tour package including Ajanta, Ellora, and nearby attractions. Flexible 1-day and 2-day options available. Suitable for families and groups. Comfortable vehicles with experienced chauffeurs provided. Affordable package pricing ensured. Smooth travel coordination guaranteed."
    },
    {
      name: "Pune to Grishneshwar Temple Taxi",
      description:
        "Spiritual travel cab service to Grishneshwar Jyotirlinga. Ideal for pilgrimage trips. AC vehicles available for comfort. Professional drivers ensure timely darshan. Transparent fare structure maintained. Safe and reliable travel service."
    },
    {
      name: "Luxury Taxi Pune to Ajanta Ellora",
      description:
        "Premium luxury cab service for heritage tours. High-end vehicles available. Superior comfort and spacious seating ensured. Professional chauffeurs provided. Ideal for executive and VIP travel. Premium travel experience guaranteed."
    },
    {
      name: "SUV Cab for Ajanta Ellora Trip",
      description:
        "Spacious SUV options for group and family travel. Extra luggage space included. Comfortable seating for long-distance ride. Smooth highway performance ensured. Ideal for 2-day tour packages. Safe and dependable journey."
    },
    {
      name: "Same Day Ajanta Ellora Cab",
      description:
        "Same-day tour cab option for quick sightseeing. Early morning pickup from Pune available. Efficient travel planning ensured. Professional driver guidance provided. Comfortable ride experience. Perfect for time-bound trips."
    },
    {
      name: "Online Cab Booking Pune to Ajanta Ellora",
      description:
        "Easy online booking with instant confirmation. Transparent fare details shared before confirmation. Secure payment options available. Flexible pickup scheduling supported. 24/7 customer support provided. Hassle-free booking experience."
    }
  ],

  tableData: [
    ["Pune to Ajanta Caves Cab", "Pune to Ellora Caves Taxi"],
    ["Pune to Ajanta Ellora Tour Cab", "Ajanta Ellora Package from Pune"],
    ["Pune to Chhatrapati Sambhaji Nagar Cab", "Pune to Ajanta One Way Taxi"],
    ["Pune to Ellora Round Trip Cab", "Affordable Ajanta Ellora Cab"],
    ["Luxury Taxi Pune to Ajanta Ellora", "SUV Cab for Ajanta Ellora Trip"],
    ["Family Trip Taxi to Ajanta Ellora", "Corporate Cab Pune to Ajanta Ellora"],
    ["Same Day Ajanta Ellora Cab", "2 Day Ajanta Ellora Taxi Package"],
    ["Online Cab Booking Pune to Ajanta Ellora", "Best Taxi Service Pune to Ajanta Ellora"],
    ["Pune to Daulatabad Fort Cab", "Pune to Grishneshwar Temple Taxi"],
    ["AC Cab Pune to Ajanta Ellora", "Outstation Cab Pune to Ajanta Ellora"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Experienced Heritage Travel Drivers",
      WhyChoosedescription:
        "Drivers familiar with Ajanta, Ellora, and surrounding heritage sites ensuring smooth and guided travel."
    },
    {
      WhyChooseheading: "Transparent Per KM Pricing",
      WhyChoosedescription:
        "Clear and honest fare structure with no hidden charges."
    },
    {
      WhyChooseheading: "Same Day & 2 Day Packages",
      WhyChoosedescription:
        "Flexible travel packages available for quick or extended sightseeing."
    },
    {
      WhyChooseheading: "Well-Maintained AC Vehicles",
      WhyChoosedescription:
        "Clean and air-conditioned sedan and SUV fleet for comfortable long-distance travel."
    },
    {
      WhyChooseheading: "Spiritual & Heritage Expertise",
      WhyChoosedescription:
        "Perfect service for pilgrimage and historical tours."
    },
    {
      WhyChooseheading: "24/7 Booking Support",
      WhyChoosedescription:
        "Round-the-clock customer assistance available."
    },
    {
      WhyChooseheading: "Family & Group Friendly",
      WhyChoosedescription:
        "Spacious vehicles ideal for group and family trips."
    },
    {
      WhyChooseheading: "Safe Long-Distance Travel",
      WhyChoosedescription:
        "Professional drivers ensure safe highway journey."
    }
  ]
};

const faqData = [
  { question: "How far are Ajanta and Ellora from Pune?", answer: "The distance is approximately 350–370 km depending on the route." },
  { question: "Can I book same-day trip?", answer: "Yes, same-day tour option is available with early pickup." },
  { question: "Is 2-day package available?", answer: "Yes, 2-day tour packages are available for relaxed sightseeing." },
  { question: "Are toll charges included?", answer: "Toll and parking are usually charged separately and informed before booking." },
  { question: "Do you provide AC vehicles?", answer: "Yes, all sedan and SUV vehicles are air-conditioned." },
  { question: "Is online booking available?", answer: "Yes, online booking with instant confirmation is available." },
  { question: "Can I visit Grishneshwar Temple?", answer: "Yes, temple visit can be included in the tour plan." },
  { question: "Are drivers experienced?", answer: "Yes, drivers are skilled and familiar with the heritage route." },
  { question: "Is round-trip service available?", answer: "Yes, round-trip and one-way services are available." },
  { question: "Is corporate group booking possible?", answer: "Yes, corporate and group bookings are supported." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Patil",
    feedback:
      "Our Ajanta Ellora tour was smooth and well-coordinated. The driver was knowledgeable and punctual. Comfortable ride throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Sharma",
    feedback:
      "Family trip to Ellora and Grishneshwar Temple was perfectly arranged. Clean vehicle and transparent pricing impressed us.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Aniket Joshi",
    feedback:
      "Booked 2-day package and everything was well managed. Safe highway travel and courteous driver. Highly recommended service.",
    rating: 5
  }
];






























































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ajanta Ellora Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-ajanta-ellora-cabs.jpg", 
  "description": "Lotus Cab offers Pune to Ajanta Ellora cabs with affordable one way, round trip, same day, and multi-day packages. Travel comfortably to Ajanta Caves, Ellora Caves, Daulatabad Fort, and Grishneshwar Temple with sedan, SUV, and luxury taxis for family, corporate, and tour trips, all with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-ajanta-ellora-cabs"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Pune to Ajanta Ellora Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Ajanta Ellora cabs with Lotus Cab. Affordable one way, round trip & multi-day packages to Ajanta, Ellora, Daulatabad Fort & Grishneshwar Temple. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Ajanta Caves Cab, Pune to Ellora Caves Taxi, Pune to Ajanta Ellora Tour Cab, Ajanta Ellora Package from Pune, Pune to Chhatrapati Sambhaji Nagar Cab, Pune to Ajanta One Way Taxi, Pune to Ellora Round Trip Cab, Affordable Ajanta Ellora Cab, Luxury Taxi Pune to Ajanta Ellora, SUV Cab for Ajanta Ellora Trip, Family Trip Taxi to Ajanta Ellora, Corporate Cab Pune to Ajanta Ellora, Same Day Ajanta Ellora Cab, 2 Day Ajanta Ellora Taxi Package, Online Cab Booking Pune to Ajanta Ellora, Best Taxi Service Pune to Ajanta Ellora, Pune to Daulatabad Fort Cab, Pune to Grishneshwar Temple Taxi, AC Cab Pune to Ajanta Ellora, Outstation Cab Pune to Ajanta Ellora" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoajantaelloracabs;